import { render, staticRenderFns } from "./pieChartBlock.vue?vue&type=template&id=431f9924&scoped=true&"
import script from "./pieChartBlock.vue?vue&type=script&lang=js&"
export * from "./pieChartBlock.vue?vue&type=script&lang=js&"
import style0 from "./pieChartBlock.vue?vue&type=style&index=0&id=431f9924&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431f9924",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/builder/shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('431f9924')) {
      api.createRecord('431f9924', component.options)
    } else {
      api.reload('431f9924', component.options)
    }
    module.hot.accept("./pieChartBlock.vue?vue&type=template&id=431f9924&scoped=true&", function () {
      api.rerender('431f9924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pieChart/pieChartBlock.vue"
export default component.exports